import { useState } from 'react';
import pkg from '../package.json';
import { Route, Routes, Link } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCubes, faClose, faStopwatch, faSquareRootVariable } from '@fortawesome/free-solid-svg-icons';

import Modal from './ui/Modal';
import TallyCounter from './tools/tally-counter/TallyCounter';
import RatioCalculator from './tools/ratio-calculator/RatioCalculator';

const App = () => {
  const [ appModal, setAppModal ] = useState(false);

  return (
    <>
      <header className="header">
        <div className="content-wrapper">
          <div className="form-group_row form-group_right">
            <button className="button button-white button-icon_only" onClick={() => setAppModal(true)}>
              <FontAwesomeIcon className="icon" icon={faCubes} />
            </button>
          </div>
        </div>
      </header>

      {
        appModal && (
          <Modal
            close={() => setAppModal(false)}
            header={(
              <div className="form-group_row form-group_right">
                <button className="button button-danger button-xs button-icon_only" onClick={() => setAppModal(false)}><FontAwesomeIcon className="icon" icon={faClose} /></button>
              </div>
            )}
            closeButton={true}
          >
            <AppMenu onNavigate={() => setAppModal(false)} />
          </Modal>
        )
      }

      <main className="main">
        <div className="content-wrapper">
          <Routes>
            {/* Homepage */}
            <Route path="/" element={
              <>
                <h2>Welcome to ZDT Tools</h2>
                <p>Select an app from the menu to get started.</p>

                <AppMenu />
              </>
            } />

            {/* Tally Counter */}
            <Route path="/tally-counter" element={
              <TallyCounter />
            } />

            {/* Ratio */}
            <Route path="/ratio-calculator" element={
              <RatioCalculator />
            } />

            {/* Catch-all for 404 */}
            <Route path="*" element={
              <>
                <h2>404 - Page Not Found</h2>
                <p>The page you are looking for does not exist.</p>
              </>
            } />
          </Routes>
        </div>
      </main>

      <footer className="footer">
        <div className="content-wrapper">
          <p>{pkg.version}</p>
        </div>
      </footer>
    </>
  );
}

const AppMenu = ({ onNavigate }) => {
  const handleClick = () => {
    if (onNavigate) onNavigate();
  };

  return (
    <div className="app-menu">
      <Link
        className="app-menu_button"
        to="/tally-counter"
        onClick={handleClick}
      >
        <FontAwesomeIcon className="icon" icon={faStopwatch} />
        <p>Tally Counter</p>
      </Link>

      <Link
        className="app-menu_button"
        to="/ratio-calculator"
        onClick={handleClick}
      >
        <FontAwesomeIcon className="icon" icon={faSquareRootVariable} />
        <p>Ratio Calculator</p>
      </Link>
    </div>
  );
};

export default App;